import React, { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

/**
 * Envoltorio para Droppable que soluciona la incompatibilidad
 * de react-beautiful-dnd con React 18 en modo StrictMode
 * mediante un ciclo de requestAnimationFrame.
 */
// react-beautiful-dnd usa Droppable.defaultProps internamente sobre un componente conectado/memo.
// En React 18.3+ esto genera la advertencia en consola.
// Eliminamos Droppable.defaultProps y proveemos parámetros por defecto nativos de JavaScript.
try {
  if (Droppable && Droppable.defaultProps) {
    delete Droppable.defaultProps;
  }
} catch (e) {}

export const StrictModeDroppable = ({
  children,
  type = 'DEFAULT',
  direction = 'vertical',
  isDropDisabled = false,
  isCombineEnabled = false,
  ignoreContainerClipping = false,
  ...props
}) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <Droppable
      type={type}
      direction={direction}
      isDropDisabled={isDropDisabled}
      isCombineEnabled={isCombineEnabled}
      ignoreContainerClipping={ignoreContainerClipping}
      {...props}
    >
      {children}
    </Droppable>
  );
};

export default StrictModeDroppable;
